module.exports = __webpack_public_path__ + "static/img/Mount-View.0385815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mount-View.jpg
// module id = tYV3
// module chunks = 0